import * as React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import TemplateIcons from './templateIcons'
import TemplateCardWrapper from './templateCardWrapper'

const TemplateCard = ({
  iconsLarge = false,
  icons,
  image,
  alt,
  isFree = true,
  to,
  href,
  linkTitle,
  padding = 2,
  shadow,
  shadowSm,
  className = '',
}) => {
  const gatsbyImage = getImage(image)

  return (
    <TemplateCardWrapper
      to={to}
      href={href}
      premium={!isFree}
      className={`${className} flex-col`}
      title={linkTitle}
      padding={padding}
      shadow={shadow}
      shadowSm={shadowSm}
    >
      <div className={`relative`}>
        <GatsbyImage className="max-w-full" image={gatsbyImage} alt={alt} />
        <TemplateIcons icons={icons} iconsLarge={iconsLarge} />
      </div>
    </TemplateCardWrapper>
  )
}

export default TemplateCard
